import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';

const DisplayImage = ({ label, url, width = '100%', className, height }) => {
	const classes = useStyles({ height });

	return (
		<div className={clsx(className?.root, classes.root)}>
			<Typography
				variant="body1"
				color="textSecondary"
				className={clsx(className?.label, classes.label)}
				gutterBottom
			>
				{label}
			</Typography>
			<img src={url} width={width} />
		</div>
	);
};

const useStyles = makeStyles((theme) => ({
	root: {
		marginBottom: 32,
		height: (props) => props.height
	},
	label: {},
	text: {}
}));

export default DisplayImage;
